import React, { useEffect, useState } from "react";
import { GetApiAccessDetails, GetContentProviderData } from "../../../api/Api";
import "./apiAccessDetails.css";
import { getFromLocalStorage } from "../../../utils/common-utils";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const ApiAccessDetails = () => {
    const [apiAccessDetails, setApiAccessDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('sandbox');
    const [showPassword, setShowPassword] = useState(false);
    const [cpList, setCpList] = useState([]);
    const [contentPartner, setContentPartner] = useState("");
    const [loaders, setLoaders] = useState({
        cpLoader: false,
    });
    const navigate = useNavigate();
    const userData = getFromLocalStorage("userData");
    const handleUnauthorized = () => {
        // Clear any stored auth tokens/user data
        Swal.fire("info!", "Session expired, please login again", "info");
        localStorage.clear();
        // Navigate to login page
        navigate("/");
    };
    console.log("userData", userData);
    const getCpList = async () => {
        setLoaders((prev) => ({ ...prev, cpLoader: true }));
        let payload = {
            pageNo: 0,
            pageSize: 1000,
            userId: userData?.id,
            status: 1,
        };
        const response = await GetContentProviderData(payload);
        console.log("resFetchBU11", response);
        setLoaders((prev) => ({ ...prev, cpLoader: false }));
        if (response?.statusDescription?.status == 200) {
            setCpList(response?.userListPage?.content);
            // Set the first content provider as default if list is not empty
            if (response?.userListPage?.content?.length > 0) {
                setContentPartner(response?.userListPage?.content[0]?.id);
            }
        } else if (response?.statusDescription?.status == 401) {
            handleUnauthorized();
        } else {
            setCpList([]);
        }
    };
    useEffect(() => {
        getCpList();
    }, []);
    console.log("cpList", cpList);
    const userId = userData?.id;
    const fetchApiAccessDetails = async (cpId, userId) => {
        console.log("cpId", cpId);
        // Only pass userId if userGroups is 4 and userId exists
        const response = await GetApiAccessDetails(
            userData.userGroups === 4 && userId ? userId : cpId
        );
        if (response?.statusDescription?.status === 200) {
            setApiAccessDetails(response.apiModel);
        }
    };

    useEffect(() => {
        // if (contentPartner) {
        fetchApiAccessDetails(contentPartner, userId);
        // }
    }, [contentPartner, userId]);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        Swal.fire({
            icon: 'success',
            title: 'Copied!',
            showConfirmButton: false,
            timer: 1500,
            position: 'top-end',
            toast: true
        });
    };

    const getActiveTabData = () => {
        if (!apiAccessDetails) return null;

        return activeTab === 'sandbox' ? {
            clientId: apiAccessDetails.clientIdTest,
            clientSecret: apiAccessDetails.clientSecretKeyTest,
            aesKey: apiAccessDetails.aesKeyTest
        } : {
            clientId: apiAccessDetails.clientId,
            clientSecret: apiAccessDetails.clientSecretKey,
            aesKey: apiAccessDetails.aesKey
        };
    };

    const activeData = getActiveTabData();

    return (
        <div className="content-wrapper">
            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="box">
                            <div className="box-body px-md-4">
                                {/* <div className="card p-4"> */}
                                    <h2 className="text-center mb-4">API Access Detail</h2>

                                    {/* Tabs using ul/li */}
                                    {userData?.userGroups !== 4 && (
                                        <div className="form-group col-sm-4 drops p-0">
                                            {/* <div className="form-group"> */}
                                            <label className="">
                                                Select Content Provider <sup className="text-danger">*</sup>
                                            </label>
                                            <div className="position-relative">
                                                <select
                                                    className={`form-control`}
                                                    name="contentPartner"
                                                    value={contentPartner}
                                                    onChange={(e) => {
                                                        const selectedCpId = e.target.value;
                                                        setContentPartner(selectedCpId);

                                                    }}
                                                    disabled={loaders.cpLoader}
                                                >
                                                    {/* <option value="" selected>
                                                        {loaders.cpLoader
                                                            ? "Loading Content Provider..."
                                                            : "--Select Content Provider --"}
                                                    </option> */}
                                                    {cpList &&
                                                        cpList?.map((item) => (
                                                            <option key={item?.id} value={item?.id}>
                                                                {item?.username}
                                                            </option>
                                                        ))}
                                                </select>
                                                {loaders.cpLoader && (
                                                    <span className="sr-only">Loading...</span>
                                                )}
                                                <div className="dropdown-icon">
                                                    <i
                                                        className="fas fa-chevron-down"
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            pointerEvents: "none",
                                                            display: loaders.cpLoader ? "none" : "block",
                                                        }}
                                                    ></i>
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                    )}
                                    <div className="mb-0 mb-md-4">
                                        <ul className="nav nav-tabs">
                                            <li className="nav-item">
                                                <a
                                                    className={`nav-link ${activeTab === 'sandbox' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('sandbox')}
                                                    role="button"
                                                >
                                                    Sandbox Details
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className={`nav-link ${activeTab === 'production' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('production')}
                                                    role="button"
                                                >
                                                    Production Details
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* Form Fields */}
                                    {/* Tabs */}


                                    {/* Form Fields */}
                                    {activeData && (
                                        <div className="api-form">
                                            <div className="form-group">
                                                <label>Client ID</label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={activeData.clientId}
                                                        readOnly
                                                    />
                                                    <span
                                                        className="input-group-text copy-button"
                                                        onClick={() => copyToClipboard(activeData.clientId)}
                                                        title="Copy Client ID"
                                                    >
                                                        <i className="fas fa-copy"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Client Secret Key</label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control"
                                                        value={activeData.clientSecret}
                                                        readOnly
                                                    />
                                                    <span
                                                        className="input-group-text"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        title={showPassword ? "Hide Secret" : "Show Secret"}
                                                    >
                                                        <i className={`fa fa-${showPassword ? 'eye' : 'eye-slash'}`}></i>
                                                    </span>
                                                    <span
                                                        className="input-group-text copy-button"
                                                        onClick={() => copyToClipboard(activeData.clientSecret)}
                                                        title="Copy Secret Key"
                                                    >
                                                        <i className="fas fa-copy"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>AES Key</label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={activeData.aesKey}
                                                        readOnly
                                                    />
                                                    <span
                                                        className="input-group-text copy-button"
                                                        onClick={() => copyToClipboard(activeData.aesKey)}
                                                        title="Copy AES Key"
                                                    >
                                                        <i className="fas fa-copy"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Notes Section */}
                                            <div className="notes-section mt-4">
                                                <h5 className="fw-bold">Notes</h5>
                                                <ul className="notes-list ps-3">
                                                    <li>Use client Id and client secret key as ClientId:ClientSecret and encode it using Base64 encoder.</li>
                                                    <li>Then you have to pass the encoded value in Api Request Header.</li>
                                                    <li>Use the {activeTab === 'sandbox' ? 'Sandbox' : 'Production'} credentials for {activeTab === 'sandbox' ? 'testing' : 'live'} environment.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ApiAccessDetails;
